<template>
    <div>
        <!-- <ul class="nav nav-tabs">
            <li class="nav-item">
                <router-link :to="{ name: 'checkin-facility-dashboard-visitor-payments-settlement' }" tag="a"
                    class="nav-link"> {{ $t("account-page-visitor-payments.title") }} </router-link>
            </li>
            <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="#">{{
                    $t("account-page-facility-payout.payout_list") }}</a>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'checkin-facility-dashboard-visitor-payments-unindentified' }" tag="a"
                    class="nav-link"> Unindentified </router-link>
            </li>
        </ul> -->
        <div class="py-3 pl-3">
            {{ $t("account-page-facility-payout.title") }}
        </div>
        <div class="row pl-3 my-3">
            <div class="col-lg-6 col-md-6 col-xl-3">
                <div class="form-group row">
                    <label class="col-5 col-form-label"> {{ $t("account-page-facility-payout.payout_date_from")
                        }}</label>
                    <div class="col-7">
                        <input v-model="filter.date_from" class="form-control" type="date" />
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xl-3">
                <div class="form-group row">
                    <label class="col-5 col-form-label"> {{ $t("account-page-facility-payout.payout_date_to") }}</label>
                    <div class="col-7">
                        <input v-model="filter.date_to" class="form-control" type="date" />
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xl-3">
                <button :disabled="!filter.date_to || !filter.date_from" type="button"
                    class="btn btn-light btn-block border bg-white" @click="search">{{
                        $t("account-page-facility-payout.search") }}</button>
            </div>
            <div class="col-lg-6 col-md-6 col-xl-3 mt-sm-3 mt-lg-0 mt-3 mt-sm-0 mt-md-0">
                <button @click="clear" type="button"
                    class="btn btn-primary btn-block border">{{ $t("account-page-facility-payout.clear") }}</button>
            </div>
        </div>
        <div class="row pl-3 my-3 justify-content-end">
            <div class="col-lg-12 col-md-12 col-xl-3 col-12">
                <button type="button" class="btn btn-primary btn-block border" @click="download">{{
                    $t("account-page-facility-payout.download") }}</button>
            </div>
        </div>
        <div class="row pl-3 my-3">
            <div class="col-lg-12 mb-4">{{ $t("account-page-visitor.timezone") }} ({{ facility.timezone ?
                facility.timezone.value : "Asia/Tokyo" }})</div>
            <div class="col-12">
                <div class="table-responsive table-bordered visitors-table">
                    <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
                        <thead>
                            <tr>
                                <th>{{ $t("account-page-facility-payout.payout_date") }}</th>
                                <th>{{ $t("account-page-facility-payout.amount") }} JPY</th>
                                <th>{{ $t("account-page-facility-payout.fee") }} JPY</th>
                                <th>{{ $t("account-page-facility-payout.net") }} JPY</th>

                                <th class="text-center">{{ $t("account-page-facility-payout.operation") }}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(value, key) in data" :key="key">
                                <td>{{ formatDate(value.arrival_date) }}</td>
                                <td>{{ formatAmount(value.amount) }}</td>
                                <td>{{ formatAmount(value.fee) }}</td>
                                <td>{{ formatAmount(value.net) }}</td>

                                <td class="text-center">
                                    <a class="btn btn-primary btn-sm cursor-pointer btn-block" href="javascript:void(0)"
                                        role="button"
                                        @click="$refs.StripeShow.view({ facility_id: facility.id, ...value })">{{
                                            $t("account-page-facility-payout.detail") }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <StripeShow ref="StripeShow" />
    </div>
</template>

<script>
import moment from "moment-timezone";
import StripeShow from "./stripeShow.vue";
import formatters from '@/mixins/formatters.js';

export default {
    components: { StripeShow },
    name: "StripePayout",
    data() {
        return {
            data: {},
            facility: window._app_facility,

            config: {},
            custom_filter: {},
            filter: {
                facility_id: window._app_facility.id,
            },
        };
    },
    async mounted() {
        await this.list(this.filter);
    },
    methods: {
        async clear() {
                this.filter.date_from = null;
                this.filter.date_to = null;

                await this.search();
        },
        async list(query) {
            this.data = await this.$lionheart.get("v2/payment/pms/payout/list", { params: query }).then((success) => success.data.data);
        },

        async search() {
            console.log(this.populateArrivalDate());
            await this.list({ facility_id: window._app_facility.id, ...this.populateArrivalDate() });
        },
        populateArrivalDate() {
            if (!isNaN(this.toUnixTS(this.filter.date_to)) && !isNaN(this.toUnixTS(this.filter.date_from))) {
                return {
                    lte: this.toUnixTS(this.filter.date_to),
                    gte: this.toUnixTS(this.filter.date_from),
                };
            }
            return {};
        },
        toUnixTS(date) {
            return Math.floor(new Date(date).getTime() / 1000);
        },
        async download() {
            await this.$lionheart
                .get("v2/payment/pms/payout/export", {
                    params: {
                        facility_id: window._app_facility.id,
                        ...this.populateArrivalDate(),
                    },
                    responseType: "arraybuffer",
                })
                .then((success) => {
                    let data = success.data;
                    const file = moment().format("YYYYMMDD");
                    let blob = new Blob([data], { type: "application/xls" });
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", `${file}_payouts.xlsx`); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
        },
    },
    mixins: [formatters],
};
</script>

<style scoped>
input[type="date"]::-webkit-calendar-picker-indicator {
    margin-left: -15px;
}
</style>
